<template>
	<div class="viewIndex">
		<div class="container">
			<div style="display: flex;width: 80%;justify-content: space-between" @mouseleave="mouseoutLeft">

				<div class="left">
					<!--                    height: blockCurrent !== null ?-->
					<!--                    blockCurrent === index ?-->
					<!--                    blockCurrentHeight :-->
					<!--                    `calc((100% - ${blockCurrentHeight}) / ${blockList.length - 1})` :-->
					<!--                    `calc(100% / ${blockList.length})`,-->
					<!--          <div v-for="(item, index) in blockList" :key="index" :class="['blockItem', blockCurrent === index ? 'hover' : '']"-->
					<!--               :style="{-->
					<!--	          backgroundImage: blockCurrent === index ? `url(${item.bannerUrl})` : '',-->
					<!--	          height: blockCurrent !== null ? blockCurrent === index ? '130px' : `calc((100% - 130px) / ${blockList.length - 1})` : `calc(100% / ${blockList.length})`,-->
					<!--          }"-->
					<div v-for="(item, index) in blockList" :key="index" :class="['blockItem', blockCurrent === index ? 'hover' : '']"
					     :style="{
	          backgroundImage: blockCurrent === index ? `url(${item.bannerUrl})` : '',
						height: blockCurrent !== null ?
                    blockCurrent === index ?
                    blockCurrentHeight :
                    `calc((100% - ${blockCurrentHeight}) / ${blockList.length - 1})` :
                    `calc(100% / ${blockList.length})`,
          }"
					     @mouseenter="mouseenterBlockItem(index)">
						<div class="title">
							<img :src="blockCurrent === index ? item.iconUrlSelected : item.iconUrl" alt="">
							<div class="name">{{ item.name }}</div>
						</div>
						<div v-if="blockCurrent === index" class="content">
							<template v-for="(ite, idx) in item.infoList" >
								<div v-if="isShowFunc(ite)" :key="idx" :class="['contentItem', contentCurrent === idx ? 'hover2' : '']"
								     @mouseenter="mouseenterLeftContent(idx)" @click="goPath(ite)" @mouseleave="autoplay = true">
									{{ ite.name }}
								</div>
							</template>

						</div>
					</div>
				</div>
				<!--      @mouseenter="clearTimer" @mouseout="setTimer"-->
				<div class="center">
					<el-carousel ref="carousel" :autoplay="autoplay" :interval="interval" arrow="never" height="calc(100vh - 230px)"
					             trigger="click">
						<el-carousel-item v-for="(item, index) in centerCurrentInfoList" :key="index" :name="item.name">
							<div class="centerWrapper" :style="{
                background: `url(${item?.bannerUrl ?? ''}) no-repeat`,
                backgroundSize: '100% 100%'
              }">
								<h1>{{ item.name }}</h1>
								<p>{{ item.content }}</p>
								<div class="tag1">
									<el-tag v-for="(it, inx) in item.tagOne?.split(',') ?? []" :key="inx" type="info">{{ it }}</el-tag>
								</div>
								<div class="tag2Wrapper">
									<div class="tag2" style="margin-top: 10px" v-for="(it, inx) in item.tagTwo?.split(',') ?? []" :key="inx">
										<img alt="" src="../../assets/icon/gou.png">
										<span>{{ it }}</span>
									</div>
								</div>

								<el-button type="primary" @click="goPath(item)">立即体验</el-button>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="right">
				<UserInfo />
			</div>
		</div>
	</div>
</template>
<script>

import {getSectorList, getToken, indexTest, getNotShowPlatformNameList, saveLogBuriedPoint} from '@/api/viewIndex';
import UserInfo from '@/views/Home/components/UserInfo.vue';
import localUrl from '@/axios/localUrl';
import {goLogin, isDev} from '@/utils/judge';

export default {
	name: 'viewIndex',
	components: {UserInfo},
	data() {
		return {
			blockList: [],
			blockCurrent: null,
			blockCurrentNew: 0,
			contentCurrent: 0,
			timer: null,
			allInfoList: [],
			autoplay: true,
			interval: 8000,
			notShowList: [],
			user: {},
		};
	},
	created() {
		const code = this.$route.query.code;
		if (code) {
			this.getToken(code);
		}
		this.init();
	},
	mounted() {
		this.user = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}')
	},
	beforeDestroy() {
		this.clearTimer();
	},
	computed: {
		blockCurrentHeight() {
			const childHeight = (this.blockList[this.blockCurrent]?.infoList?.length ?? 0) * 30;
			console.log('98 => childHeight', childHeight);
			if (childHeight + 60 < 130) {
				return `130px`;
			} else {
				return `calc(60px + ${this.centerCurrentInfoList.length * 30}px)`;
			}
		},
		centerCurrentObj() {
			const currentBlock = this.blockCurrent || this.blockCurrentNew;
			return this.blockList[currentBlock]?.infoList[this.contentCurrent] ?? {};
		},
		centerCurrentInfoList() {
			console.log(this.blockList[this.blockCurrent]?.infoList, 111111111111);
			// if (arr.length > 0) {
			// 	arr.sort(function(a, b) {
			// 		return a.sort - b.sort;
			// 	});
			// }
			return this.blockCurrent !== null ? this.blockList[this.blockCurrent]?.infoList ?? [] : this.allInfoList;
		},
	},
	methods: {
		async init() {
			const res = await getSectorList();
			await this.getNotShowPlatformNameList()
			console.log(res);
			this.blockList = res.data.result || [];
			console.log(this.blockList.length, 'bbbbbbbbbbbbbb');
			this.allInfoList = this.blockList.map(item => item.infoList ? item.infoList : {})
					.flat();
			console.log('78 => this.allInfoList', this.allInfoList);
		},
		async getToken(code) {
			const data = {
				client_id: isDev() ? 'localPortal' : 'gczxPortal',
				client_secret: isDev() ? '8230a7cd33194e90a3f49733b6da4a45' : 'ff74786bffa841fcba40a038bda148b5',
				grant_type: 'authorization_code',
				code,
			};
			let token = '';
			try {
				const res = await getToken(data);
				token = res.data.data.access_token;
				sessionStorage.setItem('token_portalUI', token);
				const res2 = await indexTest(token);
				const userInfo = res2.data.result;
				sessionStorage.setItem('userInfo_portalUI', JSON.stringify(userInfo || '{}'));
				const location = window.location;
				location.href = location.origin + location.pathname;
			} catch (e) {
				console.log(e);
				this.$message.error(e);
				sessionStorage.removeItem('token_portalUI');
				sessionStorage.removeItem('userInfo_portalUI');
				const location = window.location;
				location.href = location.origin + location.pathname;

			}
		},
		setTimer() {
			this.clearTimer();
			this.timer = setInterval(() => {
				this.blockCurrent += 1;

				if (this.blockCurrent >= this.blockList.length) {
					this.blockCurrent = 0;
				}

			}, 5000);
		},
		clearTimer() {
			clearInterval(this.timer);
			this.timer = null;
		},
		mouseoutLeft() {
			this.blockCurrent = null;
			console.log(this.blockCurrent);
		},
		mouseenterBlockItem(index) {
			this.blockCurrent = index;
			this.contentCurrent = 0;
			this.autoplay = true;
			console.log('this.blockCurrent', this.blockCurrent);
		},
		mouseenterLeftContent(index) {
			this.contentCurrent = index;
			this.autoplay = false;
			this.$refs.carousel.setActiveItem(index);
		},
		goPath(ite) {
			const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}');
			const token = sessionStorage.getItem('token_portalUI');
			console.log('185 => ite', ite);
			if (ite.urlFlag == 1) {
				if (!token) {
					goLogin();
					return;
				}
				console.log(ite, userInfo);
				const obj = userInfo.baseClientVo?.find(item => item.clientId === ite.clientId);
				if (!obj) {
					this.$message.warning('无访问权限');
					return;
				}
				if (obj && ite.url) {
					// this.$router.push(obj.visitUrl)
					window.open(ite.url, '_blank');
				} else {
					this.$message.warning('无访问地址');
				}
				this.savePoint(ite)
			} else {
				if (!ite.url) {
					this.$message.warning('无直接跳转地址');
					return;
				}
				window.open(ite.url, '_blank');
			}

		},
		isShowFunc(ite) {
			if (this.notShowList.length > 0) {
				return !this.notShowList.includes(ite.name)
			}
			return true
		},
		getNotShowPlatformNameList() {
			getNotShowPlatformNameList().then(res => {
				this.notShowList = res.data.result
			}).catch(err => {
				console.log(err);
			})
		},
		savePoint(item) {
			var stamp= new Date().getTime() + 8 * 60 * 60 * 1000;
			var createTime = new Date(stamp).toISOString().replace(/T/, ' ').replace(/\..+/, '').substring(0, 19);
			const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}')
			const data = {
				userName: this.user.nickName || userInfo.nickName,
				userId: this.user.userId || userInfo.userId,
				userPhone: this.user.mobile || userInfo.mobile,
				channel: 'A01',
				behaviorAttribute: '1',
				behaviorAttributeValue: '1',
				ip: this.$globalIP || '',
				clientCode: item.clientId,
				clientName: item.name,
				sectorInfoId: item.id,
				createTime:createTime,
				remark: JSON.stringify(sessionStorage.getItem('userInfo_portalUI'))

			}
			saveLogBuriedPoint(data).then(res => {
				console.log(res);
			}).catch(err => {})
		}
	},
};
</script>
<style lang='scss' scoped>
.viewIndex {
	height: 100%;
	width: 100%;
	background: #F5F5F5;
	display: flex;

	.container {
		//flex: 1;
		height: calc(100vh - 200px);
		width: 100%;
		padding: 15px 10px;
		display: flex;
		gap: 20px;

		.left {
			width: 24%;
			height: 100%;
			background: #fff;

			.blockItem {
				width: 100%;
				height: var(--blockItemHeight);
				background-size: 100% 100%;
				background-repeat: no-repeat;
				border-bottom: 1px solid rgba(181, 181, 181, 0.3);
				display: flex;
				flex-direction: column;
				padding-left: 20px;
				// 动画
				transition: all 0.3s;

				.title {
					display: flex;
					align-items: center;
					height: 100%;
					font-size: 16px;
					font-weight: bold;
					color: #333;

					.name {
						margin-left: 20px;
					}

					img {
						width: 20px;
						height: 20px;
					}
				}

				&.hover {
					height: 130px;

					.title {
						height: auto;
						color: #297FFD;
						margin: 20px 0 10px;
					}

					.content {
						flex: 1;
						//display: flex;
						//justify-content: space-between;
						//flex-wrap: wrap;
						margin-left: 40px;

						.contentItem {
							font-size: 14px;
							height: 30px;
							line-height: 30px;
							width: 98%;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							cursor: pointer;

							&::before {
								content: '';
								display: inline-block;
								width: 8px;
								height: 10px;
								background: url("../../assets/icon/blockIconGray.png") no-repeat;
								margin-right: 6px;
							}

							&.hover2 {
								color: #297FFD;

								&::before {
									background: url("../../assets/icon/blockIconBlue.png") no-repeat;
								}
							}

						}


					}
				}
			}
		}

		.center {
			width: 75%;
			height: 100%;
			//background: url("../../assets/images/indexCenterBg1.png") no-repeat;
			background-size: 100% 100%;
			//padding-left: 60px;
			animation: background 0.5s linear;

			h1 {
				font-size: 48px;
			}

			p {
				width: 53%;
				color: #333333;
				margin: 20px 0;
			}

			.el-button {
				width: 120px;
				height: 40px;
				font-size: 16px;
				margin-top: 25px;
			}

			.tag1 {
				.el-tag {
					margin-right: 8px;
				}
			}

			.tag2Wrapper {
				display: flex;

			}

			.tag2 {
				font-size: 14px;
				color: #333333;
				display: inline-block;
				margin-left: 7px;

				span {
					margin-left: 8px;
				}
			}

			.centerWrapper {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding-left: 60px;
			}
		}

		.right {
			width: 20%;
			height: 100%;
			background: #fff;
		}
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

::v-deep .el-carousel__indicators--horizontal {
	bottom: 34px;
	left: 40px;
	transform: none;
}

::v-deep .el-carousel__indicator.el-carousel__indicator--horizontal {
	&.is-active {
		.el-carousel__button {
			background: #297FFD;
		}
	}

	.el-carousel__button {
		background: #D0D2D7;
		opacity: 1;
		height: 5px;
	}
}
</style>
